module.exports = __webpack_public_path__ + "img/s3.dab6d78a.jpg";